import { TicketingFormCategory, FormCategory, isDrawingFormCategory } from "../enums";
import { supportsFulfillment } from "./fulfillment";
const FORBIDDEN_TERMS_ON_FORM_TITLE_AND_DESCRIPTION = ["lawrence lim teng chye"];
export const isTicketingCategory = (category) => {
    return Object.values(TicketingFormCategory).includes(category);
};
export const formCategoriesWithCheckinManager = [
    FormCategory.Event,
    FormCategory.Custom,
    FormCategory.MembershipV2,
];
const formCategoriesWithGuestTab = [
    ...formCategoriesWithCheckinManager.filter((c) => c !== FormCategory.MembershipV2),
    FormCategory.Shop,
    FormCategory.Lottery,
    FormCategory.Sweepstakes,
];
export const formHasCheckinManager = (formCategory) => formCategoriesWithCheckinManager.includes(formCategory);
export const formHasGuestTab = (formCategory) => formCategoriesWithGuestTab.includes(formCategory);
export const formHasReminderEventDetails = (formCategory) => formCategory === TicketingFormCategory.Event;
export const isEventDiscoverabilityEligible = (formCategory) => formCategory === TicketingFormCategory.Event;
export const formHasFulfillmentTab = (formCategory) => supportsFulfillment(formCategory);
export const formHasCheckInActions = (formCategory) => {
    return formCategory !== FormCategory.MembershipV2 && !isDrawingFormCategory(formCategory);
};
export const formHasCheckInOnGuestList = (formCategory) => {
    return formCategory !== FormCategory.MembershipV2 && !isDrawingFormCategory(formCategory);
};
export const formHasGuestColumnOnGuestList = (formCategory) => {
    return formCategory !== FormCategory.Shop && !isDrawingFormCategory(formCategory);
};
const normalize = (str) => {
    return str
        .toLowerCase() // lowercase the string
        .replace(/[^a-z0-9]+/gi, " ") // replace non alphanumeric characters with a space
        .replace(/\s+/g, " ") // reduce multiple spaces to a single space
        .trim(); // trim leading and trailing spaces
};
export const containsForbiddenTerm = (input) => {
    const normalizedInput = normalize(input);
    return FORBIDDEN_TERMS_ON_FORM_TITLE_AND_DESCRIPTION.some((term) => {
        return normalizedInput.includes(term);
    });
};
